import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IndexedDbService } from '../../services/indexeddb.service';
import { environment } from '../../../environments/environment';
import { paymentProcessService } from '../../services/payment-process.service';

@Component({
  selector: 'app-historical-pay-summary',
  templateUrl: './historical-pay-summary.component.html',
  styleUrls: ['./historical-pay-summary.component.css']
})
export class HistoricalPaySummaryComponent  implements OnInit {
  @Input() token: string = 'initial token!';
  paymentType: string = "fullAmount";
  totalEditedAmount: number = 0;
  currency: any;

  constructor(private router: Router, private route: ActivatedRoute, private indexedDbService: IndexedDbService, private paymentProcessService: paymentProcessService) {
    let aToken = localStorage.getItem('azuretoken');
    this.token = aToken != null ? JSON.parse(aToken) : '';
  }

  ngOnInit(){
    this.paymentProcessService.setSelectedPaymentMethod('');
  }

  cancel() {
    localStorage.removeItem("ban")
    localStorage.removeItem("cano")
    localStorage.removeItem("isSledCustomer")
    localStorage.removeItem("totalAmountToPay")
    localStorage.removeItem("InvoiceList")
    this.router.navigate(["../"], { relativeTo: this.route });
  }

  pay() {
    if (!environment.MakePyamentEnableFlag && !environment.billingProps.permissions.includes('BI-MP'))
      return this.router.navigate(["../"], { relativeTo: this.route });
    console.log("HistoricalSummary: Setting totalAmountToPay", this.totalEditedAmount.toString())
    localStorage.setItem("totalAmountToPay", this.totalEditedAmount.toString())
    return this.router.navigate(["../checkout"], { relativeTo: this.route });
  }

}
